import React from 'react';
import store from "./store/index";
import { Provider } from "react-redux";
import App from './App';
import * as serviceWorker from './serviceWorker';
import ReactDOM from 'react-dom';
const rootElement = document.getElementById("root");

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrate(<Provider store={store}><App /></Provider>, rootElement);
} else {
  ReactDOM.render(<Provider store={store}><App /></Provider>, rootElement);
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();



